<template lang="pug">
  #organization
    BLoading(
      v-if="!pageReady"
      :active="!pageReady"
    )
    WtTile(v-else vertical)
      OrganizationMobileOverview(
        :organizationName = "_.get(coreProgramMeta, 'organizationsName', 'Organization')"
        :name="_.get(mobileOrganization, 'name', '')"
        :logo="_.get(mobileOrganization, 'logo', '')"
        :creationDate="_.get(mobileOrganization, 'created', '')"
        :membersCount="_.get(mobileOrganization, 'membersCount.membersCount', 0)"
        :teams="_.get(mobileOrganization, 'teams', [])"
        :totalSteps="parseInt(_.get(mobileOrganization, 'stepsAndActivities.data_steps', 0))"
        :totalActivities="parseInt(_.get(mobileOrganization, 'stepsAndActivities.data_activities', 0))"
      )
      OrganizationMobileMembers(
        :organizationId="_.get(mobileOrganization, 'id', 0)"
        :perPage="8"
      )

</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import OrganizationMobileOverview from "@@/OrganizationMobile/OrganizationMobileOverview";
import OrganizationMobileMembers from "@@/OrganizationMobile/OrganizationMobileMembers";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "OrganizationMobile",

  components: {
    WtTitle,
    WtTile,
    OrganizationMobileOverview,
    OrganizationMobileMembers,
    WtButton
  },

  props: {},

  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),
    ...mapGetters("program", ["programLoaded", "coreProgramMeta"]),
    ...mapGetters("organizations", [
      "mobileOrganization",
      "mobileOrganizationLoaded"
    ]),

    pageReady() {
      return (
        this.memberLoaded && this.programLoaded && this.mobileOrganizationLoaded
      );
    }
  },

  watch: {},

  async mounted() {
    const response = await this.fetchMobileMember(
      this.$route.params.mobileToken
    );
    await this.fetchMobileOrganization({
      organizationId: response.organizationId,
      relations: ["membersCount", "stepsAndActivities"]
    });
  },

  methods: {
    ...mapActions("organizations", [
      "fetchMobileMember",
      "fetchMobileOrganization"
    ])
  }
};
</script>

<style lang="sass" scoped>
@media screen and (max-width: 768px)
  #organization
    background-color: white
</style>
